import { Table2 } from "lucide-react";
import {
  KpiTableParamsSchema,
  defaultKpiTableParams,
  type KpiTableParams,
} from "@playbookai/widget-schemas";
import { registerWidget } from "../registry.js";
import type { SqlWidgetDef } from "../types.js";
import { KpiTableWidget } from "./Component.js";
import { KpiTableEditor } from "./Editor.js";
import type { KpiTableView } from "./types.js";

/**
 * KPI Table — dashboard data widget. Multi-KPI sortable table + AI summary.
 * `TParams` = saved `{ kpiIds }`; `TView` = resolved `{ kpis: KpiDef[] }`.
 * Oracle default is 8-col; our grid vocabulary tops out at `wide` (6) — a
 * documented parity deviation (`WIDTH_TO_COLS` has no 8). See plan §12.
 */
export const kpiTableDef: SqlWidgetDef<KpiTableParams, KpiTableView> = {
  kind: "kpiTable",
  label: "KPI Table",
  modes: ["dashboard"],
  singleton: true,
  defaultSize: { w: 640, h: 360 },
  defaultParams: defaultKpiTableParams,
  Component: KpiTableWidget,
  storage: "sql",
  schema: KpiTableParamsSchema,
  accent: "cyan",
  icon: Table2,
  subtitle: "Multi-KPI view",
  defaultRoster: false,
  category: "single",
  layout: { col: 1, row: 1, width: 640, height: 360 },
  dashboard: {
    icon: Table2,
    defaultWidth: "wide",
    category: "Operations",
    supportsTitleOverride: true,
    EditorForm: KpiTableEditor,
  },
};

registerWidget(kpiTableDef);
